import React from "react";
import styled from "styled-components";
import bgDict from '../assets/dictionary_mockup_final.png';



const TextBox = styled("div")`
background-image: url(${bgDict});
background-position: top;
background-size: cover;
position: relative;
height:100vh;
object-fit: cover;
color: white;
width: 100%;
/* height: 100vh; */
`;


export default function MotherTongue(){
    return (
        <div>
        <TextBox></TextBox>
        </div>
    );
}